import { Pipe, PipeTransform } from '@angular/core';

const ordinals: string[] = ['th','st','nd','rd'];

/**
 * Transform a number into an ordinal string.
 * 
 * @usageNodes
 * 
 * ```html
 * <span>{{ 23 | ordinal }}</span>        <!-- renders <span>23rd</span> -->
 * <span>{{ 23 | ordinal: false }}</span> <!-- renders <span>rd</span> -->
 * ```
 */
@Pipe({ name: 'ordinal' })
export class OrdinalPipe implements PipeTransform {
    public transform(n: number, keepNumber: boolean = true) {
        let v = n % 100;
        return (keepNumber?n:'') + (ordinals[(v-20)%10]||ordinals[v]||ordinals[0]);
    }
}
